"use strict";

var _interopRequireDefault = require("reshow-runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = void 0;
var _reshowConstant = require("reshow-constant");
var _get = _interopRequireDefault(require("./get.js"));
var getImportDefault = function getImportDefault(o) {
  return (0, _get["default"])(o, [_reshowConstant.DEFAULT, _reshowConstant.DEFAULT], function () {
    return (0, _get["default"])(o, [_reshowConstant.DEFAULT], function () {
      return o;
    });
  });
};
var _default = exports["default"] = getImportDefault;
module.exports = exports.default;